<div id="header">
    <div class="current-tab">
        <i [class]="icon"></i>
        <div class="pt-1">{{ header | translate }}</div>
    </div>

    <!-- Display any custom template -->
    @if (templateRef) {
        <ng-container [ngTemplateOutlet]="templateRef"></ng-container>
    }
</div>
